import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTablePaginationDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    end: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    borders,
    colors,
    spaces
}: DataTablePaginationDynamicStyleType) => {
    const styles = {
        container: {
            borderTopColor: colors.content.border.subtle,
            paddingHorizontal: spaces.spacingMd,
            borderTopWidth: borders.separator,
            paddingVertical: spaces.spacingSm
        } as Mutable<ViewStyle>,
        more: {
            paddingBottom: spaces.spacingMd
        } as Mutable<ViewStyle>,
        end: {
            columnGap: spaces.spacingLg,
            rowGap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
